import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { get } from "lodash";

//i18n
import i18n from "../../i18n";
import languages from "../../common/languages";
import { useTranslation } from 'react-i18next';


const LanguageDropdown = () => {
  const { t } = useTranslation();
    // Declare a new state variable, which we'll call "menu"
    const [selectedLang, setSelectedLang] = useState("");

    useEffect(() => {
        // i18n zapisuje "pl" przy starcie, ale na wszelki wypadek fallback —
        // pusty kod zostawiłby goły przycisk bez napisu.
        const currentLanguage = localStorage.getItem("I18N_LANGUAGE") || i18n.language || "pl";
        setSelectedLang(currentLanguage);
    }, []);

    const changeLanguageAction = lang => {
        //set language as i18n
        i18n.changeLanguage(lang);
        localStorage.setItem("I18N_LANGUAGE", lang);
        setSelectedLang(lang);
    };


    const [isLanguageDropdown, setIsLanguageDropdown] = useState(false);
    const toggleLanguageDropdown = () => {
        setIsLanguageDropdown(!isLanguageDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown title={t('Language')} isOpen={isLanguageDropdown} toggle={toggleLanguageDropdown} className="ms-sm-1 topbar-head-dropdown header-item">
                <DropdownToggle className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle fw-semibold" tag="button">
                    <span className="fs-14">{get(languages, `${selectedLang}.code`) || ''}</span>
                </DropdownToggle>
                <DropdownMenu className="notify-item language py-2">
                    {Object.keys(languages).map(key => (
                        <DropdownItem
                            key={key}
                            onClick={() => changeLanguageAction(key)}
                            className={`notify-item ${selectedLang === key ? "active" : "none"
                                }`}
                        >
                            <span className="badge bg-light text-body fw-semibold me-2">
                                {get(languages, `${key}.code`)}
                            </span>
                            <span className="align-middle">
                                {get(languages, `${key}.label`)}
                            </span>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default LanguageDropdown;
